// Role filter schema — type-driven, mirrors server/filters.js ROLE_REGISTRY.
// The rail derives the control from `type`; enum fields carry options or a dropdown key.

const ROLE_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'open', label: 'Open' },
  { value: 'paused', label: 'Paused' },
  { value: 'filled', label: 'Filled' },
  { value: 'closed', label: 'Closed' },
];

const PLACEMENT_OPTIONS = [
  { value: 'permanent_fee', label: 'Permanent (fee)' },
  { value: 'contract_rate_card', label: 'Contract (rate card)' },
];

export const ROLE_SCHEMA = {
  groups: ['Role', 'Client', 'Classification', 'Commercial', 'Profile & JD', 'Dates'],
  fields: [
    // Role
    { key: 'title', label: 'Title', group: 'Role', type: 'text' },
    { key: 'status', label: 'Status', group: 'Role', type: 'enum', options: ROLE_STATUS_OPTIONS },
    // Client
    { key: 'client_name', label: 'Client', group: 'Client', type: 'text', dropdown: 'client_name' },
    { key: 'client_contact_name', label: 'Contact name', group: 'Client', type: 'text' },
    { key: 'client_contact_email', label: 'Contact email', group: 'Client', type: 'text' },
    // Classification
    { key: 'expertise_domain', label: 'Expertise domain', group: 'Classification', type: 'enum', dropdown: 'expertise_domain' },
    // Commercial
    { key: 'placement_model', label: 'Placement model', group: 'Commercial', type: 'enum', options: PLACEMENT_OPTIONS },
    { key: 'placement_fee_percent', label: 'Fee percent', group: 'Commercial', type: 'number', min: 0, max: 100 },
    { key: 'has_rate_cards', label: 'Has rate cards', group: 'Commercial', type: 'exists' },
    // Profile & JD
    { key: 'has_jd', label: 'Has JD on file', group: 'Profile & JD', type: 'boolean' },
    { key: 'has_role_profile', label: 'Has extracted profile', group: 'Profile & JD', type: 'boolean' },
    // Dates
    { key: 'created_at', label: 'Created date', group: 'Dates', type: 'date' },
    { key: 'updated_at', label: 'Modified date', group: 'Dates', type: 'date' },
  ],
  quick: ['status', 'expertise_domain', 'placement_model', 'has_role_profile'],
};

export const DATE_PRESETS = [
  { value: 7, label: 'Last 7 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 90, label: 'Last 90 days' },
];

const _schema = { ROLE_SCHEMA, DATE_PRESETS };
export default _schema;
